import React from 'react'
import { Button, makeStyles, createStyles, Modal as MUIModal, Theme } from '@material-ui/core'
import { useTranslation } from 'react-i18next'

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        paper: {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 350,
            backgroundColor: theme.palette.background.paper,
            border: '2px solid #000',
            boxShadow: theme.shadows[5],
            padding: theme.spacing(2, 4, 3),
        },
    })
)

type ModalProps = {
    open: boolean,
    onClose: () => void,
    name: string,
    title: string,
}

const Modal: React.FC<ModalProps> = ({ open, onClose, name, title, children }) => {
    const classes = useStyles()
    const { t } = useTranslation()

    return (
        <MUIModal
            open={open}
            onClose={onClose}
            aria-labelledby={`${name}-modal-title`}
            aria-describedby={`${name}-modal-description`}
        >
            <div className={classes.paper}>
                <h2 id={`${name}-modal-title`}>{title}</h2>

                {children}

                <Button color='primary' variant='contained' onClick={onClose} style={{ float: 'right' }}>
                    {t('dismiss')}
                </Button>
            </div>
        </MUIModal>
    )
}

export default Modal
